export const drawingPrompts = [
  "A penguin ice skating",
  "A cat playing the piano",
  "A giraffe wearing a bow tie",
  "A kangaroo boxing",
  "A sloth drinking coffee",
  "A flamingo doing yoga",
  "A panda eating spaghetti",
  "A monkey taking a selfie",
  "A hedgehog at a birthday party",
  "A hippo in a tutu",
  "A raccoon stealing cookies",
  "A koala wearing sunglasses",
  "An elephant painting a picture",
  "A turtle riding a skateboard",
  "A fox playing video games",
  "A bear baking cupcakes",
  "A rabbit doing magic tricks",
  "A squirrel playing baseball",
  "An owl reading a book",
  "A dolphin surfing",
  "A zebra having a tea party",
  "A llama wearing a scarf",
  "A hamster driving a racecar",
  "A parrot singing karaoke",
  "A tiger doing ballet",
  "A gorilla playing chess",
  "A rhinoceros gardening",
  "A cheetah riding a bicycle",
  "A penguin having a snowball fight",
  "A crocodile brushing its teeth",
  "A deer playing basketball",
  "An octopus juggling",
  "A peacock dancing",
  "A wolf cooking spaghetti",
  "A beaver building a sandcastle",
  "A chameleon painting a picture",
  "A platypus playing drums",
  "A walrus lifting weights",
  "A meerkat doing gymnastics",
  "A pig flying a kite",
  "An armadillo bowling",
  "A sheep knitting a sweater",
  "A duck playing hockey",
  "A snake wearing a top hat",
  "A chicken conducting an orchestra",
  "A frog playing leapfrog",
  "A seal balancing a ball",
  "A moose making pancakes",
  "A butterfly teaching math",
  "A cat playing the guitar",
  "A dog playing the drums",
  "A rabbit playing the piano",
  "A fox playing the saxophone",
  "A lion playing the flute",
  "A tiger playing the clarinet",
  "A giraffe in a tutu",
  "A goat riding a unicycle",
  "A jellyfish DJing",
  "A squirrel flying a jetpack",
  "A raccoon painting graffiti",
  "A hippo playing the violin",
  "A starfish doing science",
  "A kangaroo playing soccer",
  "A llama DJing",
  "A crocodile playing a banjo",
  "A porcupine dancing",
  "A bat playing the harmonica",
  "A snail skateboarding",
  "A toucan baking a cake",
  "A goldfish in a scuba suit",
  "A peacock painting",
  "A panda solving a puzzle",
  "A seagull wearing a pirate hat",
  "A donkey doing karate",
  "A platypus playing poker",
  "A whale DJing",
  "A jellyfish knitting",
  "A rooster playing a trumpet",
  "A giraffe rollerblading",
  "A camel drinking bubble tea",
  "A polar bear fishing",
  "A monkey flying a balloon",
  "A zebra skateboarding",
  "An iguana wearing a party hat",
  "A fox roasting marshmallows",
  "A dolphin playing volleyball",
  "A cheetah reading a newspaper",
  "A lobster barbecuing",
  "A raccoon playing an accordion",
  "A kangaroo baking a pie",
  "A dog flying a spaceship",
  "A beaver playing bagpipes",
  "A flamingo writing a book",
  "A horse painting a mural",
  "A cat juggling",
  "An octopus wearing sunglasses",
  "A parrot sailing a boat",
  "A sheep doing a puzzle",
  "A crab riding a bicycle",
  "A hedgehog playing chess",
  "A walrus playing a saxophone",
  "A squirrel making pancakes",
  "A chameleon wearing headphones",
  "A goat playing a piano",
  "A rhino skateboarding",
  "A bat decorating a Christmas tree",
  "A tortoise winning a race",
  "A frog painting a masterpiece",
  "A moose playing an electric guitar",
  "An otter wearing a detective hat",
  "A kangaroo playing the trombone",
  "A meerkat playing the ukulele",
  "A hamster riding a tiny train",
  "A duck wearing a superhero cape",
  "A fox eating ice cream",
  "A bunny riding a scooter",
  "A bear reading bedtime stories",
  "A snake playing chess",
  "A pig DJing",
  "A lion riding a motorcycle",
  "A deer ice skating",
  "A penguin driving a taxi",
  "A butterfly playing hopscotch",
  "A dolphin making balloon animals",
];
